export const getUser = state => state.user;



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js